import { Shell } from "../components/Shell";

export function StubPage({ title, subtitle, body }: { title: string; subtitle?: string; body?: string }) {
  return (
    <Shell title={title} subtitle={subtitle} actions={<span />}>
      <div className="panel">
        <p className="muted small">
          {body || "This section is wired but the workflow API for it is being built. The page will populate as endpoints land."}
        </p>
      </div>
    </Shell>
  );
}
